import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=de2f148e&scoped=true&"
import script from "./Distributor.vue?vue&type=script&lang=js&"
export * from "./Distributor.vue?vue&type=script&lang=js&"
import style0 from "./Distributor.vue?vue&type=style&index=0&id=de2f148e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2f148e",
  null
  
)

export default component.exports